import React from 'react';

import MultiStateButton from '../multiStateButton/multiStateButton';

import UpgradeComponent from '../upgradeComponent/upgradeComponent';
import WarningIcon from '../../../../../assets/svgComponents/WarningIcon';

import './infoComponentV2.css';

const InfoComponentV2 = ({
  isPrimaryBtn = false,
  isWarningUI = false,
  billingPlanFeature = null,
  showAnim = false,
  secondaryBtnTxt = null,
  titleTxt = '',
  subTitleTxt = '',
  btnTxt = null,
  onClick = () => {},
  stopEventPropagation = false,
  onSecondaryBtnClicked = () => {},
}) => {
  return (
    <div
      className={`et-v2-info-component-container ${
        isWarningUI ? 'et-v2-info-warning-component-container' : ''
      } ${showAnim ? 'et-v2-info-component-container-fade-in' : ''}`}>
      <UpgradeComponent billingPlanFeature={billingPlanFeature} />
      <div className="et-v2-ic-icon-title-sub-title-txt-wrap">
        <div className="et-v2-ic-warning-icon">
          <WarningIcon />
        </div>
        <div className="et-v2-ic-texts-wrap">
          {titleTxt && (
            <div className="et-v2-ic-title-txt">
              {titleTxt}
              <UpgradeComponent
                isCrown
                billingPlanFeature={billingPlanFeature}
              />
            </div>
          )}
          {subTitleTxt && (
            <div className="et-v2-ic-sub-title-txt ">{subTitleTxt}</div>
          )}
        </div>
      </div>
      <div className="et-v2-ic-btns-wrap">
        {secondaryBtnTxt && (
          <div
            className={`et-v2-ic-multi-state-btn-wrap ${!isPrimaryBtn ? 'et-v2-ic-msbtw-ghost-btn' : ''}`}>
            <MultiStateButton
              btnTxt={secondaryBtnTxt}
              onClick={onSecondaryBtnClicked}
            />
          </div>
        )}
        {btnTxt && (
          <div
            className={`et-v2-ic-multi-state-btn-wrap ${!isPrimaryBtn ? 'et-v2-ic-msbtw-ghost-btn' : ''}`}>
            <MultiStateButton
              isPrimaryBtn={isPrimaryBtn}
              btnTxt={btnTxt}
              onClick={onClick}
              stopEventPropagation={stopEventPropagation}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoComponentV2;
